// extracted by mini-css-extract-plugin
export var light = "tabbed-content-mobile-select-module--light--a040a";
export var mobileSelectContainer = "tabbed-content-mobile-select-module--mobileSelectContainer--e1afd";
export var selectArrow = "tabbed-content-mobile-select-module--selectArrow--fddcc";
export var selectFieldGroup = "tabbed-content-mobile-select-module--selectFieldGroup--84170";